import { Addition } from '@/models/Addition'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<Addition>(Addition, {
	namespaced: true
})
